import { Badge } from '@frontend-platform/ui-lib/ui';
import {
  type BuildProvenance,
  formatBuild,
  getBuildStatus,
  getBuildVariant,
} from '../lib/build-format';

// Colour treatment per build state: an active build reads as healthy, an
// inactive one as neutral, and a deleted one as a problem (the run evaluated a
// build that no longer exists).
const VARIANT_CLASS = {
  active: 'border-green-200 bg-green-50 text-green-700',
  inactive: 'border-border bg-muted text-foreground',
  error: 'border-red-200 bg-red-50 text-red-700',
} as const;

interface BuildBadgeProps {
  /** The run (or env) record carrying `manifestBuild` / `releaseActive` / `releaseAction`. */
  run: BuildProvenance;
  className?: string;
}

/**
 * "build_v22 draft (active)" pill showing which build a run evaluated. Renders
 * nothing when the record has no build — non-EP bots and pre-EP runs.
 */
export function BuildBadge({ run, className }: BuildBadgeProps) {
  const label = formatBuild(run.manifestBuild, getBuildStatus(run));
  if (!label) return null;
  return (
    <Badge
      variant="outline"
      className={`${VARIANT_CLASS[getBuildVariant(run)]} ${className ?? ''}`}
    >
      {label}
    </Badge>
  );
}
